
import { useContext } from 'react';
import { TranslationContext } from './TranslationContext';
import { translations, Language } from './translations';

export { translations };
export type { Language };

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    // Hard fallback if provider is missing (useful for SSR or outside Provider tests)
    // In this app, we should always have a provider in App.tsx
    return { 
      t: translations.en, 
      isBrazil: false, 
      lang: 'en' as Language, 
      setLanguage: (l: Language) => localStorage.setItem('platapost_lang', l),
      region: 'us',
      currency: '$',
      currencySymbol: '$',
      setRegion: (r: string) => localStorage.setItem('platapost_region', r)
    };
  }
  return context;
};
